import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/we-chat.vue
var o = {
	name: "DtIconWeChat",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--we-chat"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "We Chat",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("g", { fill: "#51c332" }, [r("path", { d: "M16.043 7.946c.408 0 .807.034 1.2.083-.71-3.125-3.992-5.488-7.938-5.488-4.466 0-8.086 3.025-8.086 6.756 0 2.151 1.21 4.06 3.087 5.295L3.24 16.729l2.904-1.247c.623.222 1.27.404 1.961.49a5.666 5.666 0 0 1-.148-1.27c0-3.725 3.627-6.756 8.086-6.756zM12 5.581c.558 0 1.01.454 1.01 1.014a1.01 1.01 0 1 1-2.02 0c0-.56.452-1.014 1.01-1.014zM6.61 7.608a1.012 1.012 0 0 1 0-2.027c.557 0 1.01.454 1.01 1.014s-.453 1.013-1.01 1.013z" }), r("path", { d: "M22.781 14.703c0-2.986-3.017-5.406-6.738-5.406-3.721 0-6.738 2.42-6.738 5.406 0 2.985 3.017 5.405 6.738 5.405.612 0 1.194-.087 1.759-.21l3.632 1.56-1.257-2.516c1.575-.99 2.604-2.511 2.604-4.24zm-8.76-.338c-.558 0-1.01-.454-1.01-1.014a1.011 1.011 0 1 1 2.021 0c0 .56-.452 1.014-1.01 1.014zm4.043 0c-.558 0-1.01-.454-1.01-1.014a1.012 1.012 0 1 1 2.021 0c0 .56-.452 1.014-1.01 1.014z" })], -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=we-chat.js.map